import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { UsersTitle, UserDataTitle } from "../../../Constants/Constants";

import UserTable from "../../DataTables/User/UserTable";
const UserContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={UsersTitle} parent={UserDataTitle} />
      <Container fluid>
        <Row>
          <UserTable />
        </Row>
      </Container>
    </>
  );
};

export default UserContainer;
